import { render, staticRenderFns } from "./RegistrationNew.vue?vue&type=template&id=d0d9d1fc&scoped=true&"
import script from "./RegistrationNew.vue?vue&type=script&lang=js&"
export * from "./RegistrationNew.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationNew.vue?vue&type=style&index=0&id=d0d9d1fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d9d1fc",
  null
  
)

export default component.exports